import React from "react"

import ItemModelV2 from "../../../../../../model2/item2/item-model"
import FieldProto from "../../../../../proto/field-proto"
import {ItemModelV2_CalculatedValues} from "../../../../../../model2/item2/calculated/@type"
import TasksView_Column from "../../../../../../model2/column/column"
import FieldRating_EditableStateful from "../../editable/rating-component"
import FieldRating from "../../../rating"
import {isBulkSelection} from "../../../../../../gd/right-click-menu"

type Props = {
    style?          : any

    listItem        : ItemModelV2
    column          : TasksView_Column
    field           : FieldProto

    onMouseEnter    : callback
    onMouseLeave    : callback
    onChange        : callback
}

export default function FieldRating_TableCellCalculated_Hovered(props: Props) {

    const onDeleteClick = (e:React.MouseEvent) => {
        if (isBulkSelection(e)) return
        e.stopPropagation()

        props.onChange(null)
    }

    const calculatedValues: ItemModelV2_CalculatedValues | undefined = props.listItem.calculated.dataByAggregateFunction[props.field.fieldId as keyof {}]?.[props.column.aggregateFunction!]
    const ownValue = calculatedValues?.own || props.field.getViewValue(props.listItem.item)

    const canEdit           = props.field.canEdit(props.listItem.item)
    const showOwnValue      = canEdit /*&& ownValue > 0*/
    const showSummaryView   = !showOwnValue && props.listItem.view.isCollapsed && !!calculatedValues?.total.value

    const classes = Classes("ui5-field-editable size-small w-100-percent h-100-percent", {
        'is-hovered': canEdit
    })

    return (
        <div className      = "cell-flex is-hovered ui5-txt-less-important-small"
             style          = {props.style}
             onMouseEnter   = {props.onMouseEnter}
             onMouseLeave   = {props.onMouseLeave}>
            <div className={classes}>
                {showSummaryView &&
                    <div className="flex-row-left-center truncate">
                        <FieldRating_EditableStateful
                            field       = {props.field as FieldRating}
                            value       = {calculatedValues?.total.value}
                            disabled    = {true}
                        />
                    </div>}

                {showOwnValue &&
                    <div className="flex-row-left-center truncate">
                        <FieldRating_EditableStateful
                            field       = {props.field as FieldRating}
                            value       = {ownValue}
                            onChange    = {props.onChange}
                            disabled    = {!canEdit}
                        />

                        <div className="buttons">
                            <div className  = "btn-reset"
                                 onClick    = {onDeleteClick}
                            />
                        </div>
                    </div>}
            </div>
        </div>
    )
}
